export default __webpack_public_path__ + "static/mpk-eeec7f50185425bc3dca5d736fe37a6c.jpg";